import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@dataplace.ai/ui-components/atoms'
import { DownloadButton } from '../AnalysePageHeader.styles'
import { ReactComponent as Download } from '../../../../../../../../../libs/shared/assets/src/lib/icons/dataplace/download.svg'
import { TOOLTIP_MAX_WIDTH } from '../../Tiles/Surroundings/Investments/utils/constants'

export interface DownloadComponentProps {
  pdfDownloadDisabled: boolean
}

function DownloadComponent({ pdfDownloadDisabled }: DownloadComponentProps) {
  const { t } = useTranslation()

  return (
    <DownloadButton
      disabled={pdfDownloadDisabled}
      type='button'
    >
      <Download />
      <span>{t('generic.download_pdf')}</span>
    </DownloadButton>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function DownloadPdfButton({ pdfDownloadDisabled }: DownloadComponentProps) {
  const { t } = useTranslation()

  return (pdfDownloadDisabled
    ? (
      <Tooltip
        content={t('placeme.download_button.disabled')}
        maxWidth={TOOLTIP_MAX_WIDTH}
        position='left top'
      >
        <DownloadComponent pdfDownloadDisabled={pdfDownloadDisabled} />
      </Tooltip>
    )
    : <DownloadComponent pdfDownloadDisabled={pdfDownloadDisabled} />
  )
}

export default DownloadPdfButton
